import React, { useEffect, useState } from 'react';
import Loader from "../../components/Loader"; 
import Paginator from "../../components/Paginator"; 
import ApiService from "../../services/ApiService";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Link , useParams, useNavigate, useSearchParams } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {formatDate} from "../../utils/helper";
import { selectStoredPermissions } from '../../stores/permissionsSlice';
import SortableList, { SortableItem } from 'react-easy-sort'

const List = () => {
    
    const [isLoader, setIsLoader] = useState(false);
    const [items, setItems] = useState([]);
    const [pagination, setPagination] = useState({});
    const [currency] = useState(process.env.REACT_APP_CURRENCY);
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
   // Initialize state from URL params
    const [apiData, setApiData] = useState({
        search: searchParams.get('search') || "",
        category_id: searchParams.get('category_id') || "",
        daterange: searchParams.get('daterange') ? 
            JSON.parse(searchParams.get('daterange')) : '',
        page: parseInt(searchParams.get('page')) || 1,
    });

    // Update URL when filters change
    useEffect(() => {
        const params = new URLSearchParams();
        if (apiData.search) params.set('search', apiData.search);
        if (apiData.category_id) params.set('category_id', apiData.category_id);
        if (apiData.daterange) params.set('daterange', JSON.stringify(apiData.daterange));
        if (apiData.page > 1) params.set('page', apiData.page.toString());
        
        navigate(`?${params.toString()}`, { replace: true });
    }, [apiData.search, apiData.daterange, apiData.page, apiData.category_id]);

    
    useEffect(() => {
        getItems();
    }, [apiData.page, apiData.search, apiData.daterange, apiData.category_id]); // Dependency array for re-fetching data

    const getItems = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "items", // Replace with your API endpoint
                data: apiData
            });
            const data = response.data;
            if (data.status) {
                setItems(data.data);
                setPagination(data.pagination);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
       
    };

    const handlePageChange = (event) => {
        setApiData(prev => ({ ...prev, page: event }));
    };

    const clearFilter = () => {
        setApiData({
            search: '',
            daterange: '',
            page: 1
        });
    };

    const delData = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'you will not be able to revert it!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "DELETE",
                url: `items/${id}`, // Replace with your API endpoint
            });
            const data = response.data;
            if (data.status) {
                getItems();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };
    // Simple array move function
    const arrayMove = (array, fromIndex, toIndex) => {
        const newArray = [...array];
        const [removed] = newArray.splice(fromIndex, 1);
        newArray.splice(toIndex, 0, removed);
        return newArray;
    };
    const onSortEndBulk = async (oldIndex, newIndex) => {
        // Update local state
        const newItems = arrayMove(items, oldIndex, newIndex);
        setItems(newItems);
        
        // Send complete reordered list to backend
        const sortedData = newItems.map((item, index) => ({
        id: item._id,
        sort_order: index + 1 // 1-based position
        }));
        
        try {
            await ApiService.request({
                method: "POST",
                url: `updateSortOrder`, 
                data: {
                    items: sortedData,
                    type: 'item'
                }
            });
        } catch (error) {
            console.error('Failed to update sort:', error);
        }
    };

 

    const updateStatus = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "you want to change its status!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4BC95F',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "POST",
                url: `items/status/${id}`, // Replace with your API endpoint
            });
            const data = response.data;
            if (data.status) {
                getItems();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0 text-capitalize">
                            Items</h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <Link to="/dashboard" className="text-muted text-hover-primary">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">Items</li>
                        </ul>
                    </div>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        {/* Add New items Button */}
                        { selectStoredPermissions().includes('create-items') &&
                            <Link to={`/items/create`}  className='btn btn-base btn-sm'>Add New Item</Link>
                        }
                    </div>
                </div>
            </div>
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    <div className="card">
                        <div className="card-header border-0 pt-6">
                            <div className="w-100">
                                <form method="get">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-items-center position-relative my-1">
                                                <input type="text" value={apiData.search} onChange={e => setApiData({ ...apiData, search: e.target.value })} className="form-control form-control-solid me-5"
                                                 placeholder="Search Item title.."/>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <DatePicker
                                                selectsRange={true}
                                                startDate={apiData.daterange[0]}
                                                endDate={apiData.daterange[1]}
                                                onChange={e => setApiData({ ...apiData, daterange: e })} 
                                                isClearable={true}
                                                maxDate={new Date()}
                                                className='form-control form-control-solid'
                                                placeholderText={('Select Daterange')}
                                            />
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <button type="button" onClick={clearFilter} className={`btn btn-sm btn-secondary mx-1 ${!apiData.search && !apiData.daterange ? 'd-none' : ''}`}>{("clear")}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <SortableList onSortEnd={onSortEndBulk} className="row" draggedItemClassName="dragged">
                                {items.length > 0 ? items.map((cat, index) => (
                                    <SortableItem  key={cat._id}>
                                        <div className="col-md-3 my-3" key={index}>
                                            <div className="card text-center shadow ">
                                                <Link to={"/addons?item_id="+cat._id}>
                                                    <img src={cat.image} alt="image" className="w-100 h-150px object-cover" />
                                                    <h5 className='my-3'>{cat.title} ({cat.title_ar})</h5> 
                                                    {cat.discounted_price ?(
                                                        <div>
                                                            <strike className="text-danger">{currency}  {cat.original_price}</strike> <br />
                                                            <span>{currency}  {cat.discounted_price}</span>
                                                        </div>
                                                    ):(
                                                        <span>{currency}  {cat.original_price}</span>
                                                    )}
                                                </Link>

                                                <div className="row my-4 mx-2">
                                                    <div className="col-4">
                                                        <div className="form-check form-switch mt-2 ">
                                                            <input className="form-check-input" type="checkbox" name="is_delivery" id="flexSwitchCheckChecked" checked={cat.status}  
                                                            onClick={() => updateStatus(cat._id)}/>
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="d-flex col-8">
                                                        <Link to={`/items/${cat._id}`} className="btn btn-sm h-30px btn-light-primary">
                                                                <i className="bi bi-eye-fill fs-6"></i>
                                                        </Link>
                                                        { selectStoredPermissions().includes('edit-items') &&
                                                            <Link to={`/items/create/${cat._id}`} className="btn btn-sm h-30px btn-light-primary">
                                                                <i className="bi bi-pencil-fill fs-6"></i>
                                                            </Link>
                                                        }
                                                        { selectStoredPermissions().includes('delete-items') &&
                                                            <button  onClick={() => delData(cat._id)} className="btn btn-sm h-30px btn-light-primary">
                                                                <i className="bi bi-trash-fill fs-6"></i>
                                                            </button>
                                                        }
                                                    </div>

                                                </div>
                                                
                                            </div>
                                        </div>
                                    </SortableItem>
                                )) : (
                                    <h6  className="text-dark text-center mt-2"> No data found!!</h6>
                                )}
                            </SortableList>
                                  
                                    {isLoader && (
                                        <Loader text="Loading" size="30" className="text-center"  />
                                    )}
                                    <span>Total Records: {pagination?.total_records}</span>


                                    {pagination.total_pages > 1 && (
                                        <Paginator
                                            page={pagination.current_page}
                                            rows={pagination.per_page}
                                            totalRecords={pagination.total_records}
                                            onPageChange={handlePageChange}
                                        />
                                    )}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;
